import type { RuleSetListItem } from '@/types/ruleSet.types';
import type { ToolSystem } from '@/types/toolSystem.types';
import { apiClient } from './client';

export const ruleSetsApi = {
  /**
   * GET /rule-sets - every hole rule set the backend knows, built-in ones included.
   *
   * `toolSystem` narrows the list to the sets written against one tool catalog, which is
   * what the project screens offer: a project cannot mix the two.
   */
  getAll: async (toolSystem?: ToolSystem | null): Promise<RuleSetListItem[]> => {
    const searchParams = new URLSearchParams();
    if (toolSystem != null) searchParams.set('tool_system', toolSystem);
    const query = searchParams.toString();
    const { data } = await apiClient.get<RuleSetListItem[]>(query ? `/rule-sets?${query}` : '/rule-sets');
    return data;
  },
};
